const pt_BR = {
  Yup: {
    cellphone_required: 'Celular é obrigatório',
    confirm_password_incorrect: 'As senhas não combinam',
    confirm_password_required: 'Confirmação de senha obrigatória',
    cpf_required: 'Cpf é obrigatório',
    cpf_incomplete: 'Complete o seu CPF',
    email_required: 'E-mail é obrigatório',
    email_type: 'O campo deve ser do tipo email. Ex: user@gmail.com',
    name_required: 'Nome é obrigatório',
    password_required: 'Senha é obrigatória',

    professional_record_required: 'Registro Profissional obrigatório',
    birth_date_required: 'Data de nascimento obrigatório',
    address_zip_code_required: 'CEP obrigatório',
    address_zip_code_incomplete: 'CEP incompleto',
    address_street_required: 'Endereço obrigatório',
    address_number_required: 'Número obrigatório',
    // address_complement_required: '',
    address_city_required: 'Cidade obrigatório',
    address_state_required: 'Estado obrigatório',
    address_country_required: 'País obrigatório',
    holder_name_required: 'Nome do titular obrigatório',
    card_expiration_required: 'Data de expiração obrigatória',
    card_number_required: 'Número do cartão obrigatório',
    card_cvv_required: 'Código de segurança obrigatório',
    registry_code_required: 'CPF do titular obrigatório',
  },
  Toast: {
    error: 'Houve um erro tente novamente.',
    success: 'Login realizado com sucesso.',
    cep_not_found: 'CEP não localizado, favor inserir endereço manualmente.',
  },
  Home: {
    button_signin: 'ENTRAR',
    button_signup: 'CADASTRE-SE',
    slogan: 'A inteligência do treinamento na palma da sua mão.',
    modal: {
      title: 'Você é:',
      professor: 'Professor',
      professor_tooltip: 'Perfil com cadastro limitado de até 300 alunos',
      gym: 'Academia',
      gym_tooltip: 'Perfil com cadastro limitado de até 1000 alunos',
      student: 'Aluno',
      student_tooltip: 'Perfil com cadastro limitado de até 300 alunos',
    },
  },
  Student: {},
  Professional: {
    SignIn: {
      title: 'Cadastre-se',
      subtitle: 'TREINADOR',
      cpf_placeholder: 'CPF',
      cpf_cnpj_placeholder: 'CPF/CNPJ',
      password_placeholder: 'Senha',
      remember_me: 'Lembrar de mim',
      forget_password: 'Esqueci minha senha',
      button_login: 'ENTRAR',
      sign_up_account: 'Não tem uma conta? ',
      sign_up_now: 'Cadastre-se agora!',
      im_student: 'Sou aluno',
      slogan_your_business: 'A inteligência do treinamento',
      slogan_your_hand: 'na palma da sua mão.',
    },
    SignUp: {
      title: 'Cadastre-se',
      subtitle: 'TREINADOR',
      name_placeholder: 'Nome',
      cpf_placeholder: 'CPF',
      email_placeholder: 'E-mail',
      password_placeholder: 'Senha',
      confirm_password_placeholder: 'Confirmar senha',
      cellphone_placeholder: 'Celular',
      conditions: 'Ao continuar, você concorda com nossos ',
      terms_of_use: 'Termos de Uso',
      and: ' e ',
      policy_privacy: 'Política de Privacidade.',
      continue: 'CONTINUAR',
      sign_in_account: 'Já tem uma conta? ',
      sign_in_login: 'Entre aqui.',
      slogan_your_business: 'O seu negócio',
      slogan_your_hand: 'na palma da sua mão.',
    },
    SignUpComplete: {
      gender_male: 'Masculino',
      gender_female: 'Feminino',
      gender_others: 'Outros',

      title: 'Complete seu cadastro',
      billing_information_title: 'Pagamento',
      name_placeholder: 'Nome',
      cpf_placeholder: 'CPF',
      professional_record_placeholder: 'Registro Profissional',
      birth_date_placeholder: 'Data de nascimento',
      gender_placeholder: 'Gênero',
      address_zip_code_placeholder: 'CEP',
      address_street_placeholder: 'Endereço',
      address_number_placeholder: 'Número',
      address_complement_placeholder: 'Complemento',
      address_neighborhood_placeholder: 'Bairro',
      address_city_placeholder: 'Cidade',
      address_state_placeholder: 'Estado',
      address_country_placeholder: 'País',
      button_continue: 'CONTINUAR',
      payment_continue: 'ASSINAR PLANO',
      plan_information_title: 'Plano selecionado: ',
      plan_information: 'Sistema de cadastro de até',
      plan_information_total_students: '250 alunos',
      holder_name: 'Nome inscrito no cartão',
      card_expiration: 'Validade',
      card_number: 'Número do cartão',
      card_cvv: 'CVV',
      registry_code: 'CPF do titular',
    },
  },

  Gym: {
    SignUp: {
      title: 'Cadastre-se',
      subtitle: 'ACADEMIA',
      company_name_placeholder: 'Nome',
      cnpj_placeholder: 'CNPJ',
      email_placeholder: 'E-mail',
      password_placeholder: 'Senha',
      confirm_password_placeholder: 'Confirmar senha',
      cellphone_placeholder: 'Celular',
      conditions: 'Ao continuar, você concorda com nossos ',
      terms_of_use: 'Termos de Uso',
      and: ' e ',
      policy_privacy: 'Política de Privacidade.',
      continue: 'CONTINUAR',
      sign_in_account: 'Já tem uma conta? ',
      sign_in_login: 'Entre aqui.',
      slogan_your_business: 'O seu negócio',
      slogan_your_hand: 'na palma da sua mão.',
    },
  },
};

export default pt_BR;
